/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import Accesspage from './../../../common/404';
import Patients_List from './patients-list';
import Patient_history from './patient-history';
import On_bed_patient from './on-bed-patient';
import On_Bed_Patient_details from './on-bed-patient-details';

class Patient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date()
        };
    }
    componentDidMount() {
        // console.log(this.props);
    }
    renderbodyLayer() {
        const { slug } = this.props.match.params
        const { menuList } = this.props;
        console.log('data');
        console.log(this.props);
        let obj = null;
        menuList.map(data => {
            var subData = data
                .submenu
                .find(o => o.route === slug);
            console.log(subData);
            if (subData != undefined) {
                obj = subData;
            }
        })
        var page = null;
        console.log("Queue Screen");
        console.log(obj, slug);
        if (obj !== undefined) {
            switch (slug) {
                case 'patients-history':
                    page = <Patients_List {...this.props} menuList={menuList} />;
                    break;
                case 'patients-history-details':
                    page = <Patient_history {...this.props} menuList={menuList} />;
                    break;
                case 'onbed-patients':
                    page = <On_bed_patient {...this.props} menuList={menuList} />;
                    break;
                case 'on-bed-patient-details':
                    page = <On_Bed_Patient_details {...this.props} menuList={menuList} />;
                    break;   
                
                default:
                    let submenu = null;
                    if (menuList[0]['submenu'].length !== 0) {
                        submenu = menuList[0]['submenu'][0]['route']
                    }
                    if (submenu !== null) {
                        this
                            .props
                            .history
                            .push(`/${menuList[0]['route']}/${submenu}`);
                    } else {
                        this
                            .props
                            .history
                            .push(`/${menuList[0]['route']}}`);
                    }
                   
                    break;
            }
        } else {
            page = <Accesspage></Accesspage>;
        }

        return page;
    }
    render() {

        return (
            <div>
                {this.renderbodyLayer()}
            </div>
        );
    }
}

export default Patient;
